import { render, staticRenderFns } from "./theme.vue?vue&type=template&id=574da822&"
import script from "./theme.vue?vue&type=script&lang=js&"
export * from "./theme.vue?vue&type=script&lang=js&"
import style0 from "./theme.vue?vue&type=style&index=0&id=574da822&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports